import {
  AppLayout,
  ContentLayout,
  BreadcrumbGroupProps,
  AppLayoutProps,
} from '@cloudscape-design/components';
import { useContext } from 'react';

import { LocalNavigation, Breadcrumbs, NavigationContext } from '../common/navigation';

export type ViewLayoutProps = {
  header?: React.ReactNode;
  secondaryHeader?: React.ReactNode;
  breadcrumbs?: BreadcrumbGroupProps.Item[];
  children?: React.ReactNode;
  contentType?: AppLayoutProps.ContentType;
  headerVariant?: 'default' | 'high-contrast';
  hideNavigation?: boolean;
};

export function ViewLayout(props: ViewLayoutProps) {
  const { navigationSize, navigationOpen, setNavigationOpen } = useContext(NavigationContext);

  return (
    <AppLayout
      breadcrumbs={props.breadcrumbs ? <Breadcrumbs items={props.breadcrumbs} /> : undefined}
      className="app-layout"
      content={
        <ContentLayout
          header={props.header}
          headerVariant={props.headerVariant}
          secondaryHeader={props.secondaryHeader}
        >
          {props.children}
        </ContentLayout>
      }
      contentType={props.contentType ?? 'default'}
      headerSelector=".top-navigation"
      headerVariant={props.headerVariant}
      navigation={<LocalNavigation />}
      navigationHide={props.hideNavigation}
      navigationOpen={navigationOpen}
      navigationWidth={navigationSize}
      toolsHide
      onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
    />
  );
}
